import $ from 'jquery';
import jQuery from 'jquery';
import focusPoint from 'jquery-focuspoint';
import 'popper.js';
import 'bootstrap';
import 'slick-carousel';
import Cookie from 'js-cookie';
import PerfectScrollbar from 'perfect-scrollbar';


var scrollOffset = 120;
var body = $('body');

if ($(window)
    .width() < 992) {
    scrollOffset = 63;
}

/***
 * Initialize Focus point
 */
$('.focuspoint')
    .focusPoint();

/***
 * ReCaptcha Form submit
 * Check if form is valid before executing grecaptcha
 */

$('form.form-recaptcha').submit(function(e) {
    if ($(this).find('.g-recaptcha').length > 0) {
        e.preventDefault();

        var vacancyFormSource = $(this)
            .find('.initialTrafficSource');

        if (vacancyFormSource) {
            var trafficSource = getCookie('initialTrafficSource');

            $('.initialTrafficSource')
                .val(trafficSource);

        }

        grecaptcha.execute();
    }
});


$(window)
    .on('resize', function(event) {
        if ($(window)
            .width() >= 992) {
            window.viewport = 'lg-block';
        } else {
            window.viewport = 'lg-none';
        }
    });

/***
 * Custom query string builder vacancies overview
 */
function filterFormAction() {
    var queryObject = {};
    $('.filterCheckbox[data-viewport="' + window.viewport + '"]')
        .each(function() {
            if ($(this)
                .is(':checked')) {
                var value = $(this)
                    .val();
                var name = $(this)
                    .attr('name');
                if (!(name in queryObject)) {
                    queryObject[name] = [];
                }
                queryObject[name].push(value);

            }
        });
    var query = $('.filterQuery')
        .val();
    if (query && query != '') {
        queryObject['query'] = query;
    }
    var order = $('.current-order')
        .attr('data-order');
    if (order && order != '') {
        queryObject['order'] = order;
    }

    var queryString = '';
    var count = 0;
    for (var key in queryObject) {
        if (count == 0) {
            queryString += '?' + key + '=';
        } else {
            queryString += '&' + key + '=';
        }
        if (Array.isArray(queryObject[key])) {
            queryString += queryObject[key].join();
        } else {
            queryString += queryObject[key];
        }
        count++;
    }
    window.location = document.location.pathname + queryString;
}

function capitalizeFirstLetter(string) {
    return string.charAt(0)
        .toUpperCase() + string.slice(1);
}

$('.filterCheckbox')
    .click(function() {
        window.viewport = $(this)
            .attr('data-viewport');
        filterFormAction();
    });
$('#filterForm')
    .submit(function(e) {
        e.preventDefault();
        filterFormAction();
    });
$('.change-order')
    .click(function() {
        var order = $(this)
            .attr('data-value');
        $('.current-order')
            .attr('data-order', order)
            .text(capitalizeFirstLetter(order));
        filterFormAction();
    });

/***
 * Image Slider
 */

$('.image-slider-pp .image-slider')
    .slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        padding: 32,
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

/***
 * Superstar Slider
 */

$('.superstar-slider')
    .slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        autoplay: true
    });

/***
 * GetCookie
 */
function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

/***
 * Toggle Mobile Navigation
 */

$('.mobile-nav-toggle')
    .click(function() {
        $(this)
            .toggleClass('active');
        body.toggleClass('mobile-nav-visible');
    });

/***
 * Scroll to anchor
 */

$('a[href*="#"]:not(a[href="#"]):not(a.collapse-toggle)')
    .click(function(e) {
        var hash = $(this)
            .attr('href');
        var scrollPos = ($(hash)
            .offset().top - scrollOffset);
        $('html,body')
            .animate({scrollTop: scrollPos}, 'slow');
        e.preventDefault();
    });

/***
 * Scroll to apply
 */

if ($('div[data-scroll]').length > 0) {
    var scrollPos;
    if ($('.help-block').length === 0) {
        scrollPos = ($('div[data-scroll]')
            .offset().top - scrollOffset);
    } else {
        scrollPos = ($('div[data-scroll] .help-block')
            .offset().top - scrollOffset);
    }
    $('html,body')
        .animate({scrollTop: scrollPos}, 'slow');
}

/***
 * Prevent dropdown from closing
 */

$('.dropdown-menu')
    .on('click', 'button', function(event) {
        event.preventDefault();
        event.stopPropagation();
    });

/***
 * Replace all SVG images with inline SVG
 */

jQuery('img[src*="svg"]')
    .each(function() {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data)
                .find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');
    });

/**
 * Announcement Popup
 */

var announcement = $('.announcement-popup--js');
var announcementCookie = parseInt(Cookie.get('announcementCookie'));

// If announcement-popup is present
if (announcement.length > 0) {
    // Activate scrollbar
    var pscontainer = document.querySelector('.announcement-popup__content--js');
    var ps = new PerfectScrollbar(pscontainer);
    pscontainer.addEventListener('ps-scroll-up', function() {
        $('.announcement-popup__content-wrapper')
            .addClass('announcement-popup__content-wrapper--up')
            .removeClass('announcement-popup__content-wrapper--down');
    });
    pscontainer.addEventListener('ps-scroll-down', function() {
        $('.announcement-popup__content-wrapper')
            .addClass('announcement-popup__content-wrapper--down')
            .removeClass('announcement-popup__content-wrapper--up');
    });

    // Check if value of annoucementCookie and announcement data-date are not the same
    if (announcementCookie !== announcement.data('date')) {
        // Show announcement-popup
        announcement.addClass('announcement-popup--active');
        $('html, body')
            .addClass('announcement-popup--visible');
        // Set cookie to data-date
        Cookie.set('announcementCookie', announcement.data('date'));
    }
}

// Toggle announcement-popup class on toggle click
$('.announcement-popup__toggle--js, .announcement-popup__close--js, .announcement-popup__bg')
    .click(function() {
        announcement.toggleClass('announcement-popup--active');
        $('html, body')
            .toggleClass('announcement-popup--visible');
    });

/*******************************************************************************************************************
 * Apply Form Address logic
 ******************************************************************************************************************/

var applyForm = $('.apply-form');

if (applyForm.length > 0) {
    var typingTimer;
    var doneTypingInterval = 2000;
    var zipCodeVal = '';
    var houseNumberVal = '';
    var tokenVal = applyForm.find('input[name="address_token"]')
        .val();

    function doneTyping() {
        applyForm.find('.address-alert__error--js')
            .hide();
        applyForm.find('.address-alert__loading--js')
            .show();
        var url = '/get-address/' + zipCodeVal + '/' + houseNumberVal;
        $.post(url, {'address_token': tokenVal}, function(data) {
            applyForm.find('[data-internal-name="street"] :input')
                .val(data.street);
            applyForm.find('[data-internal-name="city"] :input')
                .val(data.city);
            applyForm.find('.address-alert__loading--js')
                .hide();
        })
            .fail(function() {
                applyForm.find('[data-internal-name="street"] :input')
                    .val('');
                applyForm.find('[data-internal-name="city"] :input')
                    .val('');
                applyForm.find('.address-alert__error--js')
                    .show();
                applyForm.find('.address-alert__loading--js')
                    .hide();
            });
    }

    applyForm.find('[data-internal-name]')
        .on('keyup input blur', function() {
            clearTimeout(typingTimer);

            if ($(this)
                .data('internal-name') === 'zipcode') {
                zipCodeVal = $(this)
                    .find(':input')
                    .val();
            }

            if ($(this)
                .data('internal-name') === 'housenumber') {
                houseNumberVal = $(this)
                    .find(':input')
                    .val();
            }

            if (zipCodeVal !== '' && houseNumberVal !== '') {
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            }
        });
}



// WEBPACK FOOTER //
// ./assets/ui/js/app.js